import { useSelector } from "react-redux";
import {
  getClasseId,
  getCsrfToken,
  getCurrentDiagnostique,
  getElevePositionnement,
  getLoggedOutState,
  getOnBoardingState,
  getSchollId,
  getUserId,
  getUserStatus,
} from "redux_dir/features/userSlice";

function useGetUserInfo() {
  const onBoarding = useSelector(getOnBoardingState);
  const loggedOut = useSelector(getLoggedOutState);
  const userId = useSelector(getUserId);
  const userStatus = useSelector(getUserStatus);
  const schoolId = useSelector(getSchollId);
  const csrfToken = useSelector(getCsrfToken);
  const diagnostiqueType = useSelector(getCurrentDiagnostique);
  const classeId = useSelector(getClasseId);
  const eleve = useSelector(getElevePositionnement);
  const eleveId = eleve?.id;

  return {
    onBoarding,
    loggedOut,
    userId,
    userStatus,
    eleveId,
    schoolId,
    classeId,
    csrfToken,
    diagnostiqueType,
  };
}

export default useGetUserInfo;
